import { type GasPayload } from '@atlaskit/analytics-gas-types';

export const onQueryFilterSelected = ({
	actionSubjectId,
	attributes,
	nonPrivacySafeAttributes,
}: {
	actionSubjectId: string;
	attributes: Record<string, any>;
	nonPrivacySafeAttributes: Record<string, any>;
}): GasPayload => ({
	eventType: 'track',
	action: 'selected',
	actionSubject: 'queryFilter',
	actionSubjectId,
	attributes,
	nonPrivacySafeAttributes,
});
